import React from 'react';

// Toast
import { toast } from 'react-toastify';

// Axios
import axios from 'axios';

// MUI Components
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';

const ErrorLogRow = ({ errorLog, clearLog }) => {

    const deleteErrorLog = (id) => {
        axios.post(`/error-log/${id}/delete`).then(response => {
            if( response.data.success ){
                toast.success(response.data.message);
                clearLog(id);
            }
            else{
                toast.error(response.data.message);
            }
        });
    }

    return (
        <Box className='error-log-row'>
            <p className='error-log-path'>{errorLog.path}</p>
            <p className='error-log-size'>{errorLog.size}</p>
            <Button className='error-log-delete-button' variant='text' color='error' onClick={() => deleteErrorLog(errorLog.id)}>
                <DeleteIcon />
            </Button>
        </Box>
    )

}

export default ErrorLogRow;